module.exports = __webpack_public_path__ + "static/media/YF46_5.6efbdea8.jpg";